import type { ErrorInfo } from 'react';

type ErrorAttributes = {
	errorName?: string;
	errorMessage?: string;
	errorStack?: string;
	componentStack?: ErrorInfo['componentStack'];
};

export const getErrorAttributes = (error: unknown, errorInfo?: ErrorInfo): ErrorAttributes => {
	if (error === undefined && !errorInfo) {
		return {};
	}
	return {
		errorName: error instanceof Error ? error.name : undefined,
		errorMessage:
			error instanceof Error ? error.message : typeof error === 'string' ? error : undefined,
		errorStack: error instanceof Error ? error.stack : undefined,
		componentStack: errorInfo?.componentStack,
	};
};
